<div class="container">
  <div class="main-div">
    <div class="center-pane">
      <div class="form-div">
        <div class="header">
          <div class="logo">
            <img src="assets/logo-full.svg"/>
          </div>
          <h2 i18n="@@merchantLoginTitle">Login to your account</h2>
          <p i18n="@@merchantLoginSubtitle">Enter your e-mail address and password to login.</p>
        </div>
        <!-- emailItem -->
        <input-text-field (onchange)="updateInputFieldById('email', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="emailLabel"
                          [group]="signInForm"
                          [id]="'email'"
                          [inputType]=InputType.email
                          [validators]=[Validators.required,Validators.email]
        ></input-text-field>
        <!-- PasswordItem -->
        <input-text-field (onchange)="updateInputFieldById('password', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="passwordLabel"
                          [group]="signInForm"
                          [id]="'password'"
                          [inputType]=InputType.password
                          [validators]=[Validators.required]
        ></input-text-field>
        <div class="forget-password">
          <button (click)=" onForgotPassword()" class="forget-password-button btn" i18n="@@forgotPasswordTitle">Forgot password?</button>
        </div>
        <div *ngIf="serverError !== null"
             class="alert alert-danger form-alert">{{ serverError }}</div>
        <primary-button
          (onClick)="onLoginSubmitted()"
          [loading]="isLoading"
          [showArrow]="true"
          [title]="loginLabel">
        </primary-button>
      </div>
    </div>
  </div>
</div>
